var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIconThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0054 16.0279L16.4847 26.566L16.4844 26.5664L16.4844 26.5664L16 27.1026L5.9946 16.0279C3.96093 13.7769 3.703 10.2912 5.23232 7.72747C5.45026 7.36212 5.70437 7.01575 5.9946 6.6945C8.30745 4.13447 12.0458 4.13447 14.3587 6.6945L15.1441 7.56391C15.6133 8.08319 16.3852 8.08362 16.8549 7.56504L16.8549 7.56498L16.8559 7.56393L16.8559 7.56391L17.6413 6.6945C19.667 4.45233 22.7815 4.17694 25.0745 5.85269C25.4029 6.09275 25.7152 6.37326 26.0054 6.6945C28.3315 9.26922 28.3315 13.4532 26.0054 16.0279Z",
    fill: "#FFFBFF",
    stroke: "#1E1E1E",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIconThin);
export default __webpack_public_path__ + "static/media/heart-icon-thin.df4500653886b0bef7ce591dfb05d9d1.svg";
export { ForwardRef as ReactComponent };